import React, { useMemo } from 'react';
import { PictureWithFallback } from '../../../sections/PictureWithFallback';
import { CloseIcon } from '../../../svg/CloseIcon';
import { AdminIncomingChatBubble } from './AdminIncomingChatBubble';
import { useAppState } from '../../../../client/providers/AppProvider';
import { Espin_Role_Enum } from '../../../../generated/spin-graphql';
import { useMessagesContext } from '../../../../pages/dashboard/messages';

type Props = {
    onBackClicked: () => void;
    selectedConversation: AdminConversation;
};

export type AdminConversation = {
    nameLabel: string;
    messages: { message: string; date: string; playerUserId?: string }[];
};

export const AdminSelectedConversation: React.FC<Props> = ({ onBackClicked, selectedConversation }) => {
    const nameLabel = selectedConversation.nameLabel;
    const { user } = useAppState();
    const { messagesState } = useMessagesContext();

    const parentMessages = useMemo(() => {
        if (!!messagesState.selectedChildId && user?.role === Espin_Role_Enum.EspinParentUser) {
            const tempConvoObj = selectedConversation.messages.reduce((r, a) => {
                r[a.playerUserId] = r[a.playerUserId] || [];
                r[a.playerUserId].push(a);
                return r;
            }, Object.create(null));
            return Object.values(tempConvoObj[messagesState.selectedChildId]);
        } else {
            return null;
        }
    }, [selectedConversation.messages, user?.role, messagesState.selectedChildId]);

    return (
        <>
            <div className="header-container">
                <div className="image-wrapper">
                    <PictureWithFallback width={40} height={40} icon={null} alt={`${nameLabel}'s profile picture`} />
                </div>
                <div className="username">{nameLabel}</div>
                <button onClick={onBackClicked} className="button circle-button back-button">
                    <CloseIcon />
                </button>
            </div>
            <div className="content">
                <div className="chat-bubbles-container">
                    {((!!parentMessages ? parentMessages : selectedConversation.messages) as {
                        message: string;
                        date: string;
                        playerUserId?: string;
                    }[]).map((message, index) => {
                        return (
                            <AdminIncomingChatBubble key={`chat-bubble-${index}`} picture={null} message={message} />
                        );
                    })}
                </div>
            </div>
        </>
    );
};
